import { FlattenSimpleInterpolation } from '@mui/styled-engine-sc';

export type StyledPropsExpression =
	| false
	| FlattenSimpleInterpolation
	| undefined;
